import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { CREATE_RULE, LIST_RULE } from 'commons/constants/permissions'

const RulesListPage = lazy(() => import('pages/Rules/List'))
const RulesCreatePage = lazy(() => import('pages/Rules/Create'))

export default [
  {
    path: '/rules',
    component: RulesListPage,
    permissions: LIST_RULE,
  },
  {
    path: '/rules/create',
    component: RulesCreatePage,
    permissions: CREATE_RULE,
  },
] as Route[]
